export const animationDurationMs = 500;
